import Vue from 'vue';
import Router from 'vue-router';

//const home = r => require.ensure([], () => r(require('../page/home/home')), 'home')
//const hello = r => require.ensure([], () => r(require('../components/HelloWorld')), 'Hello')

const adjoinSearch = () => import('@/page/home/search');//云对接首页
const adjoinDetail = () => import('@/page/home/detail');//云对接详情
const adjoinDetailLibrary = () => import('@/page/detail/LibraryLists');// 云对接-对接更多人才项目列表
const adjoinDetailCollege = () => import('@/page/detail/CollegeLists');// 云对接-对接更多人才项目列表
const adjoinDetailDynamic = () => import('@/page/detail/DynamicLists');// 云对接-更多动态
const adjoinTarget = () => import('@/page/target');//云对接详情的相关需求
const adjoinSample = () => import('@/page/sample');//云对接详情的相关需求

Vue.use(Router);

export default new Router({
    mode: "history",
    base: "/public/adjoin",
    routes: [
        {path: '*', redirect: 'index'},
        {path: '/index', name: 'adjoinSearch', component: adjoinSearch},

        /*{path: '*', redirect: '/search'},
        {path: '', redirect: '/search'},
        {path: '/', redirect: '/search'},
        {path: '/search', name: 'adjoinSearch', component: adjoinSearch},
        {path: '/detail', name: 'adjoinDetail', component: adjoinDetail},*/

        {path: '/detail/library', name: 'adjoinDetailLibrary', component: adjoinDetailLibrary},
        {path: '/detail/college', name: 'adjoinDetailCollege', component: adjoinDetailCollege},
        {path: '/detail/dynamic', name: 'adjoinDetailDynamic', component: adjoinDetailDynamic},
        {path: '/target', name: 'adjoinTarget', component: adjoinTarget},
        {path: '/sample', name: 'adjoinSample', component: adjoinSample},

        {path: '/:id', name: 'adjoinDetail', component: adjoinDetail}
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js